import { useAccount } from '@azure/msal-react';
import { Avatar, Menu, Stack, Text } from '@mantine/core';
import { IconBell, IconBookmark } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';

import { ColorSchemeToggleButton } from './ColorSchemeToggleButton';
import classes from './UserMenu.module.css';

export function UserMenu() {
  const account = useAccount();

  return (
    <Menu shadow="md" position="right" withArrow>
      <Menu.Target>
        <Avatar color="dark.5" variant="filled" className={classes.avatar} />
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item component="button">
          <Stack gap={0} align="flex-start">
            <Text size="sm" fw={500}>
              {account?.name}
            </Text>

            <Text c="dimmed" size="xs">
              {account?.username}
            </Text>
          </Stack>
        </Menu.Item>
        <Menu.Item>
          <ColorSchemeToggleButton />
        </Menu.Item>

        <Menu.Divider />

        <Menu.Item leftSection={<IconBookmark size={14} />} component={Link} to="/bookmarks">
          My Dashboards
        </Menu.Item>
        <Menu.Item leftSection={<IconBell size={14} />} component={Link} to="/notifications">
          Notifications
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
